import type { Translation } from "@/i18n/locales/types";

export const my: Translation["my"] = {
  certificates: "My certificates",
  activity: "My activity",
  certificatesDescription:
    "To use them, open Punto.Firma on your Mac and sign in with this account.",
  downloadApp: "Download the app",
  empty: {
    title: "You can't use any certificate yet",
    description:
      "Ask an administrator of your organization to give you access to the ones you need.",
  },
  card: {
    expires: "expires {{date}}",
    expiresSoon: "Expires {{when}}",
    where: "Where",
    uses: "For",
    notAllowed: "Not allowed: {{items}}.",
    notAllowedItem: "{{what}} on {{sede}}",
    somePaths: "some pages",
    suspended: "Suspended by your administrator",
    noValidVersion: "No valid version: your administrator has to renew it",
    nowhere: "No allowed sites",
  },
  activityDescription:
    "Your signatures and your browsing with cloud certificates. Your organization's administrators can see them too.",
  activityTabs: {
    signatures: "My signatures",
    navigation: "My browsing",
  },
};
